module.exports = __webpack_public_path__ + "img/logo_curi_insurance_blue_horizontal.86924f52.svg";